import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../Text';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import styles from '@dtsl/css-bulk-action/dist/index.module.css';
import Warning from '@dtsl/icons/dist/icons/react/Warning';
function NoAction(props) {
  const {
    noActionsText,
    mobileNoActionsText
  } = props;
  const {
    isMobile
  } = useIsMobile(640);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['sib-bulk-action__noaction']
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Warning, null)), /*#__PURE__*/React.createElement(Text, {
    size: "lg",
    tag: "span"
  }, isMobile ? mobileNoActionsText : noActionsText));
}
NoAction.propTypes = {
  selectAllButtonProps: PropTypes.object,
  noActionsText: PropTypes.string,
  mobileNoActionsText: PropTypes.string
};
export default NoAction;